import { getField, updateField } from 'vuex-map-fields'

const parseTraveler = function(traveler) {
  let res = {
    id: traveler.id,
    for_destroy: false,
    for_attach: false,
    name: traveler.name,
    email: traveler.email,
    is_adult: !traveler.is_adult,
    parent_name: !traveler.is_adult ? traveler.parent.name : '',
    parent_email: !traveler.is_adult ? traveler.parent.email: ''
  }

  return res
}

const newTraveler = function() {
  return {
    id: '_' + Math.random().toString(36).substr(2, 9),
    for_destroy: false,
    for_attach: true,
    name: '',
    email: '',
    is_adult: false,
    parent_name: '',
    parent_email: ''
  }
}
  
const newPossibleTraveler = function(possible_traveler) {
  return {
    id: '_' + Math.random().toString(36).substr(2, 9),
    for_destroy: false,
    for_attach: true,
    name: possible_traveler.name,
    email: possible_traveler.email,
    is_adult: false,
    parent_name: '',
    parent_email: ''
  }
}

// if adult - required name, email
// if child - required name, parent_name, parent_email
const defaultState = {
  people: 0,
  list: []
}

const actions = {}

const mutations = {

  updateField,

  FETCH(state, payload) {
    let {list_real, list_possible, people} = payload
    console.log(payload)
    console.log(list_real)
    console.log(list_possible)

    state.people = people
    state.list = []

    if (list_real.length == 0 && list_possible.length > 0) {
      list_possible.map((possible_traveler) => {
        state.list.push(newPossibleTraveler(possible_traveler))
      })
    } else {
      list_real.map((traveler) => {
        state.list.push(parseTraveler(traveler))
      })
    }
    // prefill empty
    if (state.list.length < people-1) {
      let difference = people - 1 - state.list.length
      for (let i = 0; i < difference; i++){
        state.list.push(Object.assign({}, newTraveler()))
      }
    }
  },

  ADD(state) {
    state.list.push(Object.assign({}, newTraveler()))
    state.people++
  },

  REMOVE(state, id) {
    let index = state.list.findIndex(traveler => traveler.id == id)
    let traveler = state.list[index]
    if (traveler.for_attach) {
      state.list.splice(index, 1)
    } else {
      traveler.for_destroy = true
    }
    state.people--
  }
}

const getters = {
  getField
}

export default {
  namespaced: true,
  state: defaultState,
  actions: actions,
  mutations: mutations,
  getters: getters
}
